class VwReferansDoktorDTO {
    id: number = null;
    kimlikId?: number = null;
    ekleyenKullanici?: number = null;
    eklemeTarihi?: string = null;
    guncelleyenKullanici?: number = null;
    guncellemeTarihi?: string = null;
    adi?: string = "";
    soyadi?: string = "";
    aileAdi?: string = "";
    kimlikNo?: string = "";
    pasaportNo?: string = "";
    bransId?: number = null;
    baslangicTarihi?: string = null;
    bitisTarihi?: string = null;
    kurumAdi?: string = "";
    aciklama?: string = "";
    aktif?: string = "";
    hakedisoran?: number = null;
    doktorNo?: string = "";
    kurumId?: number = null;
    satisPersonelId?: number = null;
    fkKurumAdi?: string = "";
    satisPersonelAdi?: string = "";
    satisPersonelSoyadi?: string = "";
    satisPersonelAileAdi?: string = "";
}
export default VwReferansDoktorDTO;